import React from "react";

import { LoginRedirect } from "@src/domains/Redirects/LoginRedirect";
import { ShareRoute } from "@src/features/shareResults/Share.route";

import LoginPage from "../../components/Login/LoginPage";

export const PUBLIC_ROUTES = {
  Login: "/login",
  Share_Id: "/share/:id",
};

export const GeneralPublicRoutes = [
  {
    path: PUBLIC_ROUTES.Login,
    element: <LoginRedirect />,
  },
  {
    path: "*",
    element: <LoginPage />,
  },
];
